<template>
  <div class="pa-6">
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Statut d'emploi</legend>

        <!-- Block Statut emploi -->
        <div>
          <!-- Informations Statut emploi -->
          <div>
            <RessourceInfoBulle code="PI-SE-1" />
            <RessourceInfoBulle code="PI-SE-2" />

            <p class="font-weight-bold">
              Retrouvez plus d'information pour définir votre statut d'emploi
              <a href="https://www.otstcfq.org/membres/statut-demploi" target="_blank" class="link-trim-space">ici</a>.
            </p>
          </div>

          <v-autocomplete
            v-model="statutEmploi.statutDEmploi"
            :item-text="itemText"
            :item-value="itemValue"
            :items="listeStatutDEmploi"
            :rules="rules.statutDEmploi"
            class="cssRequired"
            label="Statut d'emploi"
            required
            return-object
            @change="statutEmploiChange"
          ></v-autocomplete>

          <template v-if="isTSouTCFstatutMembreOuAutoriseASInscrire">
            <v-autocomplete
              v-if="isPrecisionStatutRequired"
              v-model="statutEmploi.precisionStatut"
              :class="isPrecisionStatutRequired && 'cssRequired'"
              :item-text="itemText"
              :item-value="itemValue"
              :items="listePrecisionsStatutFilter"
              :required="isPrecisionStatutRequired"
              :rules="rules.precisionStatut"
              label="Précision statut"
              return-object
              @change="precisionStatutChange"
            ></v-autocomplete>

            <v-text-field
              v-model="statutEmploi.complementPrecisionStatut"
              :class="isComplementPrecisionRequired && 'cssRequired'"
              :required="isComplementPrecisionRequired"
              :rules="rules.complementPrecisionStatut"
              label="Complément précision statut"
            ></v-text-field>

            <!-- Dates de congés -->
            <div v-if="isConges" class="d-flex">
              <div class="mr-6">
                <v-menu
                  ref="menuDebutConge"
                  v-model="debutCongeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="290px"
                  offset-y
                  required
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-sheet max-width="200">
                      <v-text-field
                        v-model="statutEmploi.dateDebutConges"
                        v-mask="'####-##-##'"
                        :rules="rules.dateDebutConges"
                        append-icon="mdi-calendar"
                        class="cssRequired"
                        hint="Format YYYY-MM-DD"
                        label="Date début congés"
                        readonly
                        required
                        v-bind="attrs"
                        v-on="on"
                      />
                    </v-sheet>
                  </template>
                  <v-date-picker
                    :max="statutEmploi.dateFinDeCongesSiConnue"
                    ref="debutCongePicker"
                    v-model="statutEmploi.dateDebutConges"
                    required
                    @change="saveDebutConge"
                  />
                </v-menu>
              </div>
              <div>
                <v-menu
                  ref="menuFinConge"
                  v-model="finCongeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="290px"
                  offset-y
                  required
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-sheet max-width="200">
                      <v-text-field
                        v-model="statutEmploi.dateFinDeCongesSiConnue"
                        v-mask="'####-##-##'"
                        :rules="rules.dateFinDeCongesSiConnue"
                        append-icon="mdi-calendar"
                        class="cssRequired"
                        hint="Format YYYY-MM-DD"
                        label="Date fin congés"
                        readonly
                        required
                        v-bind="attrs"
                        v-on="on"
                      />
                    </v-sheet>
                  </template>
                  <v-date-picker
                    :min="statutEmploi.dateDebutConges"
                    ref="finCongePicker"
                    v-model="statutEmploi.dateFinDeCongesSiConnue"
                    required
                    @change="saveFinConge"
                  />
                </v-menu>
              </div>
            </div>
          </template>
        </div>
      </fieldset>

      <fieldset>
        <legend class="text-h6 text-sm-h5">Lieu(x) de travail</legend>

        <RessourceInfoBulle code="PI-SE-3" />
        <div v-if="!isSansEmploi" class="legalSection section-margin">
          <p class="mentionLegal" style="font-weight: bold">
            Avez-vous un autre lieu de travail ?
            <v-btn color="primary" @click="ajouter()">Ajouter</v-btn>
          </p>
        </div>

        <v-expansion-panels ref="panels" v-model="panel" class="section-margin" focusable>
          <CarteDAffairePro
            v-for="item in listeAdressesPro"
            :key="item.internalIndex"
            :item="item"
            :valid="valid"
            @adressePrincipaleUnique="adressePrincipaleUnique"
            @edition="dupliquerPourEdition"
            @openDialog="openDialog"
            @validate-form="validateForm"
          >
          </CarteDAffairePro>
        </v-expansion-panels>

        <section v-if="!isSansEmploi && listeAdressesPro.length === 0" class="legalSection body-2 section-margin">
          <RessourceInfoBulle code="PI-SE-4" />
        </section>
        <section v-if="isSansEmploi && listeAdressesPro.length > 0" class="legalSection body-2 section-margin">
          <RessourceInfoBulle code="PI-SE-5" />
        </section>
        <section v-else-if="listeAdressesPro.length > 0 && !valid && isHeaderValid" class="legalSection body-2 section-margin">
          <RessourceInfoBulle code="PI-SE-6" />
        </section>
      </fieldset>
    </v-form>
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid || !isAdressesValid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>

    <v-dialog v-model="dateFinDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline"> Fin de fonction ou désactivation </v-card-title>
        <div v-if="dateMinDialog === null">
          <v-card-text class="subtitle-1">
            Vous devez renseigner une date de début avant de pouvoir supprimer votre lieu de travail.
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" text @click="cancelDialog"> Retour </v-btn>
          </v-card-actions>
        </div>
        <div v-else>
          <v-card-text class="subtitle-1">
            Vous êtes sur le point de supprimer votre lieu de travail. Merci d'indiquer la date de fin et valider.
          </v-card-text>
          <v-card-text class="subtitle-1">
            <v-menu
              ref="menuDateFin"
              v-model="dateFinMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              autocomplete="off"
              min-width="200px"
              offset-y
              required
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-sheet>
                  <v-text-field
                    v-model="dateFinValue"
                    v-mask="'####-##-##'"
                    append-icon="mdi-calendar"
                    class="cssRequired"
                    hint="Format YYYY-MM-DD"
                    label="Date de fin"
                    readonly
                    required
                    v-bind="attrs"
                    v-on="on"
                  />
                </v-sheet>
              </template>
              <v-date-picker ref="dateFinPicker" v-model="dateFinValue" :min="dateMinDialog" required @change="saveDateFin" />
            </v-menu>
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" text @click="cancelDialog"> Annuler </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteRow(deletingLieuxDeTravail)"> Valider </v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import Loader from "../Loader"
import CarteDAffairePro from "../common/CarteDAffairePro"
import { isTsOuTcfStatutMembreOuAutoriseASInscrire } from "@/utils/autorisationHelper"
import NavigationPageFormulaireInscriptionMixin from "@/mixins/navigationPageFormulaireInscriptionMixin"
import { getExtranetUrl } from "@/utils/stringUtils"

export default {
  mixins: [NavigationPageFormulaireInscriptionMixin],
  props: {
    routeName: {
      type: String,
      default: "",
    },
  },
  components: {
    Loader: Loader,
    CarteDAffairePro,
  },
  data() {
    return {
      urlEspaceFormationLara: getExtranetUrl(process.env.VUE_APP_FORMATION_XTRANET),
      overlay: false,
      messageSelector: "",
      valid: true,
      panel: null,
      dateFinDialog: false,
      dateFinMenu: false,
      dateFinValue: null,
      deletingLieuxDeTravail: null,
      dateMinDialog: null,
      debutCongeMenu: false,
      finCongeMenu: false,
      rules: {
        statutDEmploi: [(v) => !!v || "Le statut d'emploi est requis"],
        precisionStatut: [(v) => !this.isPrecisionStatutRequired || !!v || "La précision du statut est requise"],
        complementPrecisionStatut: [(v) => !this.isComplementPrecisionRequired || !!v || "Le complément de précision est requis"],
        dateDebutConges: [(v) => !this.isConges || !!v || "La date de début de congés est requise"],
        dateFinDeCongesSiConnue: [(v) => !this.isConges || !!v || "La date de fin de congés est requise"],
      },
    }
  },
  created() {
    this.fetchItems()
  },
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      demandeInscriptionPpId: "DemandeInscription/GET_CONTACTID",
      cartesDAffaires: "CarteDAffaire/getCartesDAffaires",
      getAutorisations: "AutorisationDePratique/GET_AUTORISATIONSDEPRATIQUE",
      statutEmploi: "StatutEmploi/getStatutEmploi",
      getStatutsEmploi: "Catalogue/getStatutsEmploi",
      getPrecisionsStatut: "Catalogue/getPrecisionsStatut",
    }),
    listeAdressesPro() {
      return this.cartesDAffaires.filter((c) => c.active)
    },
    isTSouTCFstatutMembreOuAutoriseASInscrire() {
      return isTsOuTcfStatutMembreOuAutoriseASInscrire(this.getAutorisations)
    },
    isConges() {
      if (this.statutEmploi.statutDEmploi) {
        return (
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.congesDivers ||
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.congesMaternite
        )
      } else {
        return false
      }
    },
    isSansEmploi() {
      if (this.statutEmploi.statutDEmploi) {
        return (
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.sansEmploi ||
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.retraiteMoins10ans ||
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.retraitePlus10ans ||
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.etudeTempsPleinSansRevenu
        )
      }

      return false
    },
    listePrecisionsStatutFilter() {
      return this.getPrecisionsStatut.filter(
        (p) => this.statutEmploi.statutDEmploi != null && p.parent == this.statutEmploi.statutDEmploi.id
      )
    },
    listeStatutDEmploi() {
      return this.getStatutsEmploi
    },
    isPrecisionStatutRequired() {
      if (this.statutEmploi.statutDEmploi) {
        return this.listePrecisionsStatutFilter.length > 0
      } else {
        return false
      }
    },
    isComplementPrecisionRequired() {
      if (this.statutEmploi.statutDEmploi) {
        return (
          this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.autreDomaine ||
          (this.statutEmploi.statutDEmploi.id == this.$catalogues.statutDEmploi.congesDivers &&
            this.statutEmploi.precisionStatut &&
            this.statutEmploi.precisionStatut.id == this.$catalogues.precisionStatutDEmploi.autre)
        )
      }

      return false
    },
    isAdressesValid() {
      if (this.isSansEmploi) {
        return this.hasAdressesActive === false
      }

      return this.hasPlusieursAdressesPrincipales === false && this.hasAdressesActive
    },
    hasPlusieursAdressesPrincipales() {
      return this.cartesDAffaires.filter((c) => c.principalPro === true).length > 1
    },
    hasAdressesActive() {
      return this.listeAdressesPro.length > 0
    },
    isHeaderValid() {
      let result = true

      for (const key in this.rules) {
        let rule = this.rules[key]

        if (rule instanceof Array) {
          rule = rule[0]
        }

        result = result && rule(this.statutEmploi[key]) === true
      }

      return result
    },
  },
  methods: {
    ...mapMutations({
      addCarteDAffaire: "CarteDAffaire/addCarteDAffaire",
      removeCarteDAffaire: "CarteDAffaire/removeCarteDAffaire",
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getDefaultCarteDAffairePro: "CarteDAffaire/getDefaultCarteDAffairePro",
      fetchCartesDAffairesProByContactId: "CarteDAffaire/fetchCartesDAffairesProByContactId",
      createCarteDAffaire: "CarteDAffaire/createCarteDAffaire",
      updateCarteDAffaire: "CarteDAffaire/updateCarteDAffaire",
      createOrganisation: "Organisation/createOrganisation",
      getAutorisationDePratiqueByDemandeInscriptionId: "AutorisationDePratique/getAutorisationDePratiqueByDemandeInscriptionId",
      getStatutEmploiByDemandeInscriptionId: "StatutEmploi/getStatutEmploiByDemandeInscriptionId",
      updateStatutEmploi: "StatutEmploi/updateStatutEmploi",
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        const requests = [
          this.getCatalogue(this.$cataloguesDesc.pays),
          this.getCatalogue(this.$cataloguesDesc.province),
          this.getCatalogue(this.$cataloguesDesc.fonction),
          this.getCatalogue(this.$cataloguesDesc.heuresPratiqueAutonome),
          this.getCatalogue(this.$cataloguesDesc.adapteHandicape),
          this.getCatalogue(this.$cataloguesDesc.domaineDePratique),
          this.getCatalogue(this.$cataloguesDesc.typeClientele),
          this.getCatalogue(this.$cataloguesDesc.methodeIntervention),
          this.getCatalogue(this.$cataloguesDesc.approcheIntervention),
          this.getCatalogue(this.$cataloguesDesc.serviceOffert),
          this.getCatalogue(this.$cataloguesDesc.typeTherapie),
          this.getCatalogue(this.$cataloguesDesc.typeActiviteReservee),
          this.getCatalogue(this.$cataloguesDesc.typeProbleme),
          this.getCatalogue(this.$cataloguesDesc.serviceReferenceEnLigne),
          this.getCatalogue(this.$cataloguesDesc.statutEmploi),
          this.getCatalogue(this.$cataloguesDesc.precisionStatutEmploi),
        ]

        if (this.demandeInscriptionPpId) {
          requests.push(this.fetchCartesDAffairesProByContactId(this.demandeInscriptionPpId))
        }

        if (this.demandeInscriptionId) {
          requests.push(this.getStatutEmploiByDemandeInscriptionId(this.demandeInscriptionId))
          requests.push(this.getAutorisationDePratiqueByDemandeInscriptionId(this.demandeInscriptionId))
        }

        await Promise.all(requests)

        // hack: vide le statut si il n'est pas dans la liste
        // vuetify ne permet pas ce comportement natif, voir: https://github.com/vuetifyjs/vuetify/issues/4000
        if (!this.getStatutsEmploi.some(s => s.id === this.statutEmploi.statutDEmploi?.id)) {
          this.statutEmploi.statutDEmploi = null
        }

        this.validateForm(true)
        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    validateForm(resetValidation = false) {
      this.valid = this.$refs.form.validate() && this.isAdressesValid

      if (resetValidation) {
        this.$refs.form.resetValidation()
      }
    },
    saveAndContinue() {
      this.save()
    },
    async save() {
      this.messageSelector = "Save"
      this.overlay = true
      this.validateForm()

      if (this.valid && this.cartesDAffaires != null) {
        for (const carteDAffaire of this.cartesDAffaires) {
          if (this.demandeInscriptionId) {
            carteDAffaire.demandeInscription = this.demandeInscriptionId
          }

          if (this.demandeInscriptionPpId) {
            carteDAffaire.pp = this.demandeInscriptionPpId
          }

          if (!carteDAffaire.pm && carteDAffaire.organisation && !carteDAffaire.organisation.id) {
            carteDAffaire.organisation.statutEmployeur = { id: process.env.VUE_APP_ORGANISME_STATUT_NONVALIDEE }
            carteDAffaire.pm = await this.createOrganisation(carteDAffaire.organisation)
          }

          // set de la date de fin de la carte d'affaire précédente, TODO -1 jour ?
          if (carteDAffaire.cartePrecedente && carteDAffaire.dateDEntreeEnFonction) {
            carteDAffaire.cartePrecedente.dateDeFinDeFonction = carteDAffaire.dateDEntreeEnFonction
          }

          if (carteDAffaire.id == null) {
            await this.createCarteDAffaire(carteDAffaire)
          } else {
            // Permet de désactiver les cartes modifiées
            await this.updateCarteDAffaire(carteDAffaire)
          }
        }

        await this.updateStatutEmploi(this.statutEmploi)

        this.next()
      } else {
        this.$refs.panels.$el.scrollIntoView({ behavior: "smooth" })
      }
      this.overlay = false
    },
    async dupliquerPourEdition(carteDAffaire) {
      if (!carteDAffaire) {
        return
      }

      const clone = Object.assign({}, carteDAffaire)
      carteDAffaire.active = false
      clone.id = null
      clone.cartePrecedente = carteDAffaire // hook pour la gestion de la date de fin

      this.adressePrincipaleUnique(clone)

      await this.ajouter(clone)
    },
    async ajouter(carte = null) {
      if (!this.cartesDAffaires) {
        return
      }

      const carteDAffaire = carte || (await this.getDefaultCarteDAffairePro())
      carteDAffaire.pp = this.demandeInscriptionPpId
      carteDAffaire.demandeInscription = this.demandeInscriptionId
      carteDAffaire.internalIndex = this.cartesDAffaires.length

      if (carte === null) {
        carteDAffaire.pratiqueAutonome = this.getPratiqueAutonomeSelonStatutEmploi()
      }

      this.addCarteDAffaire(carteDAffaire)

      // Ouverture de la carte pour saisie
      this.$nextTick(() => {
        this.panel = this.listeAdressesPro.length - 1
      })
    },
    deleteRow(item) {
      this.removeCarteDAffaire({ item: item, dateFin: this.dateFinValue })

      this.cancelDialog()
      this.validateForm()
    },
    saveDateFin(date) {
      this.$refs.menuDateFin.save(date)
    },
    openDialog(item) {
      if (item.id === null && item.cartePrecedente == null) {
        this.deleteRow(item)

        return
      }

      if (item.dateDEntreeEnFonction != null) {
        this.dateMinDialog = item.dateDEntreeEnFonction
      }

      this.deletingLieuxDeTravail = item
      this.dateFinDialog = true
    },
    cancelDialog() {
      this.deletingLieuxDeTravail = null
      this.dateMinDialog = null
      this.dateFinValue = null
      this.dateFinDialog = false
    },
    adressePrincipaleUnique(item) {
      if (item.principalPro === true) {
        this.cartesDAffaires.filter((c) => c.id != item.id).forEach((c) => (c.principalPro = false))
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,

    saveDebutConge(date) {
      this.$refs.menuDebutConge.save(date)
    },
    saveFinConge(date) {
      this.$refs.menuFinConge.save(date)
    },
    precisionStatutChange() {
      this.setPratiqueAutonomeCarteCreation()
    },
    setPratiqueAutonomeCarteCreation() {
      const nombreCarteDAffaire = this.listeAdressesPro.length

      if (nombreCarteDAffaire === 1) {
        const carteDAffaire = this.listeAdressesPro[0]
        const pratiqueAutonome = this.getPratiqueAutonomeSelonStatutEmploi()

        // Mise à jour de la carte d'affaire en cours de création
        if (carteDAffaire.id == null && pratiqueAutonome) {
          carteDAffaire.pratiqueAutonome = pratiqueAutonome
        }
      }
    },
    getPratiqueAutonomeSelonStatutEmploi() {
      if (this.statutEmploi.statutDEmploi && this.statutEmploi.precisionStatut) {
        return (
          this.statutEmploi.statutDEmploi.id === this.$catalogues.statutDEmploi.enEmploi &&
          this.statutEmploi.precisionStatut.id === this.$catalogues.precisionStatutDEmploi.pratiqueAutonome
        )
      }

      return false
    },
    statutEmploiChange() {
      this.statutEmploi.precisionStatut = null
      this.validateForm(true)
    },
    membreDUnAutreOrdreChange() {
      if (!this.statutEmploi.membreDUnAutreOrdre) {
        this.statutEmploi.specifier = null
        this.validateForm(true)
      }
    },
    detenezVousUnBaccOuMaitriseEnTSChange() {
      if (!this.statutEmploi.detenezVousUnBaccOuMaitriseEnTS) {
        this.statutEmploi.universite = null
        this.validateForm(true)
      }
    },
  },
}
</script>

<style></style>